import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useCatch, useEffectAsync } from "../../helper/reactHelper";
import { PanelFooter } from "../panel/panel";

const EditItemView = ({ children, endpoint, item, setItem, defaultItem, validate, onItemSaved }) => {
    const { id } = useParams();
    const history = useHistory();

    useEffectAsync(async () => {
        if (!item) {
            if (id) {
                const response = await fetch(`/api/${endpoint}/${id}`);
                if (response.ok) {
                    setItem(await response.json());
                } else {
                    throw Error(await response.text());
                }
            } else {
                setItem(defaultItem || {});
            }
        }
    }, [id, item, defaultItem]);

    const handleSave = useCatch(async () => {
        let url = `/api/${endpoint}`;
        if (id) {
            url += `/${id}`;
        }

        const response = await fetch(url, {
            method: !id ? "POST" : "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(item),
        });
        if (response.ok) {
            if (onItemSaved) {
                onItemSaved(await response.json());
            }
            history.goBack();
        } else {
            throw Error(await response.text());
        }
    });

    return (
        <div>
            {item && children}
            <PanelFooter className="text-center border-1">
                <button onClick={() => history.goBack()} className="btn btn-default btn-lg ms-5px mb-2" disabled={!item}>
                    Cancelar
                </button>
                <button disabled={!item || !validate()} onClick={handleSave} className="btn btn-green btn-lg ms-5px mb-2">
                    Guardar Cambios
                </button>
            </PanelFooter>
        </div>
    );
};

export default EditItemView;
